import { render, staticRenderFns } from "./ContentWidget.vue?vue&type=template&id=38171658&scoped=true&"
import script from "./ContentWidget.vue?vue&type=script&lang=js&"
export * from "./ContentWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContentWidget.vue?vue&type=style&index=0&id=38171658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38171658",
  null
  
)

export default component.exports